import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import { autoAnimatePlugin } from '@formkit/auto-animate/vue';
import ElementPlus from 'element-plus';
import en from 'element-plus/dist/locale/en.mjs';
import { createPinia } from 'pinia';
import type { App as AppConfig } from 'vue';
import { markRaw } from 'vue';
import resize from 'vue-resize-directive';
import { Router } from 'vue-router';

import { clickOutside } from '@/directives/click-outside';
import { onSticky } from '@/directives/sticky';
import { i18n } from '@/i18n';
import i18nPlugin from '@/i18n/plugin';

export function addVuePlugins(app: AppConfig, router?: Router) {
  if (!app) return;
  const pinia = createPinia();
  app.use(pinia);

  if (router) {
    app.use(router);
    pinia.use(({ store }) => { store.router = markRaw(router); });
  }

  app.use(i18n);
  app.use(i18nPlugin);

  app.use(ElementPlus, { locale: en });
  app.use(autoAnimatePlugin);

  Object.entries(ElementPlusIconsVue).forEach(([key, component]) => {
    app.component(key, component);
  });

  app.directive('resize', resize);
  app.directive('sticky', onSticky());
  app.directive('clickOutside', clickOutside());
}
